<template>
    <Layout>
        <PageHeader :title="title" :items="breadCrumbs" :prev="{name:'browse-space',params:{}}"/>
        <p>The user profile is a collection of settings and information associated with you and your business. It includes critical information such as user details, business details, and business address.</p>
        <div class="card custom-style">
            <div class="card-body">
                <div class="row">
                    <div class="mb-4 box-title">Change Password</div>
                    <ValidationObserver v-slot="{ handleSubmit, reset }" ref="observer">
                        <b-form ref="changePassForm" @submit.prevent="handleSubmit(requestChangePassword)" @reset.prevent="reset">
                            <b-form-group class="mb-4">
                                <label>Your Current Password</label>
                                <validation-provider name="password" rules="required" v-slot="validationContext" ref="currentPass">
                                    <b-input-group>
                                        <b-form-input @focusin="isCurrentPasswordForceInvalid = false" :state="getValidationState(validationContext, 'currentPassword')" placeholder="Enter Your Current Password" v-model="currentPassword" type="password" trim></b-form-input>
                                    </b-input-group>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="mb-4">
                                <label>New Password</label>
                                <validation-provider name="newPassword" rules="required|verify_password" v-slot="validationContext" ref="newPassX">
                                    <b-input-group>
                                        <template #append>
                                            <b-input-group-text class="toggle-password" :class="{
                                'input-text-red':
                                  getValidationState(validationContext) === false,
                                'input-text-green':
                                  getValidationState(validationContext) === true,
                              }" @click="() => (isShowNewPassword = !isShowNewPassword)">&nbsp; <i class="far" :class="{
                                  'fa-eye': isShowNewPassword,
                                  'fa-eye-slash': !isShowNewPassword,
                                }"></i>
                                            </b-input-group-text>
                                        </template>
                                        <b-form-input 
                                          class="mb-2 no-border-right" 
                                          :state="getValidationState(validationContext, 'newPassword')" 
                                          placeholder="Enter New Password" 
                                          name="newPassword" 
                                          v-model="newPassword" 
                                          :type="isShowNewPassword ? 'text' : 'password'" 
                                          @focusin="showPasswordVerification"
                                          @focusout="hidePasswordVerification"
                                          trim
                                          ></b-form-input>
                                    </b-input-group>
                                     <div class="password-verification" v-if="isPasswordVerificationActive">
                                        <div class="mb-1">Password must include:</div>
                                        <b-row>
                                            <b-col :class="{ green: validationData.oneCapital }" cols="4">
                                                <i :class="{ grey: !validationData.oneCapital }" class="fas fa-check-circle"></i> Atleast 1 capital letter
                                            </b-col>
                                            <b-col :class="{ green: validationData.oneNumber }" cols="4">
                                                <i :class="{ grey: !validationData.oneNumber }" class="fas fa-check-circle"></i> Atleast 1 number
                                            </b-col>
                                            <b-col cols="4"></b-col>
                                            <b-col :class="{ green: validationData.oneLower }" cols="4">
                                                <i :class="{ grey: !validationData.oneLower }" class="fas fa-check-circle"></i> Atleast 1 lower letter
                                            </b-col>
                                            <b-col :class="{ green: validationData.oneSymbol }" cols="5">
                                                <i :class="{ grey: !validationData.oneSymbol }" class="fas fa-check-circle"></i> Atleast 1 symbol (ex: ?@#)
                                            </b-col>
                                            <b-col cols="3"></b-col>
                                            <b-col :class="{ green: validationData.eightCharacter }" cols="4">
                                                <i :class="{ grey: !validationData.eightCharacter }" class="fas fa-check-circle"></i> Atleast 8 characters
                                            </b-col>
                                            <b-col cols="4"></b-col>
                                            <b-col cols="4"></b-col>
                                        </b-row>
                                    </div>
                                </validation-provider>
                            </b-form-group>
                            <b-form-group class="mb-4">
                                <label>Confirm New Password</label>
                                <validation-provider name="confirm new password" rules="required|confirmed:newPassword" v-slot="validationContext" ref="confirmNewPass">
                                    <b-input-group>
                                        <template #append>
                                            <b-input-group-text class="toggle-password" :class="{
                                'input-text-red':
                                  getValidationState(validationContext) === false,
                                'input-text-green':
                                  getValidationState(validationContext) === true,
                              }" @click="() => (isShowConfirmNewPassword = !isShowConfirmNewPassword)">&nbsp; <i class="far" :class="{
                                  'fa-eye': isShowConfirmNewPassword,
                                  'fa-eye-slash': !isShowConfirmNewPassword,
                                }"></i>
                                            </b-input-group-text>
                                        </template>
                                        <b-form-input class="mb-2 no-border-right"  :state="getValidationState(validationContext)" placeholder="Confirm New Password" v-model="confirmNewPassword" :type="isShowConfirmNewPassword ? 'text' : 'password'" trim></b-form-input>
                                            
                                    </b-input-group> 
                                    <span class="custom-invalid-feedback">{{ validationContext.errors[0] }}</span> 
                                </validation-provider>
                            </b-form-group>

                            <div class="text-end"> <!-- Add text-end class to right-align -->
                                <div class="d-flex justify-content-md-end justify-content-lg-end">
                                    <router-link to="/pages/profile">
                                        <button class="btn btn-secondary me-3" type="button">
                                            Cancel
                                        </button>
                                    </router-link>
                                    <button class="btn btn-primary" type="button" @click="changePassword">
                                        <i class="fa fa-save mx-1"></i> Save Changes
                                    </button>
                                </div>
                            </div>
                        </b-form>
                    </ValidationObserver>
                </div>
            </div>
        </div>
    </Layout>
</template>
<script scoped>
    import Layout from "../../../layouts/main.vue";
    import PageHeader from '@/components/page-header-custom.vue';
    import {
        authMethods,
        layoutMethods,
        layoutComputed

    } from "@/state/helpers";

    export default {
        data() {
            return {
                title: "User Profile",
                // Show Password Variables
                isShowNewPassword: false,
                isShowConfirmNewPassword: false,
                // Some error variables
                isShowError: false,
                errorMessage: null,
                isRequestLoading: false,
                newPassword: null,
                currentPassword: null,
                confirmNewPassword: null,
                isPasswordVerificationActive: false,
                isCurrentPasswordForceInvalid: false,
                isNewPasswordForceInvalid: false
            };
        },
        components: {
            Layout,
            PageHeader
        },
        computed: {
          ...layoutComputed,
            validationData() {
                var validationData = {
                    oneCapital: this.newPassword && this.newPassword.match(/[A-Z]/),
                    oneNumber: this.newPassword && this.newPassword.match(/[0-9]/),
                    oneLower: this.newPassword && this.newPassword.match(/[a-z]/),
                    oneSymbol: this.newPassword &&
                        //eslint-disable-next-line
                        this.newPassword.match(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/),
                    eightCharacter: this.newPassword && this.newPassword.length >= 8,
                };
                return validationData;
            },
        },
        mounted() {
          this.changeBreadCrumb({
            breadCrumbs: [
                { text: "User Profile", to: { name: "profile" } },
                { text: 'Edit Profile', to: { name: 'edit-profile'} },
                { text: 'Change Password', to: { name: 'edit-profile-password'} }
            ],
        });
        },
        methods: {
            ...layoutMethods,
            ...authMethods,
            togglePasswordVisibility() {
              this.isShowNewPassword = !this.isShowNewPassword;
            },
            showPasswordVerification() {
                this.isNewPasswordForceInvalid = false
                this.isPasswordVerificationActive = true;
            },
            hidePasswordVerification() {
              if (this.newPassword === '') {
                this.isPasswordVerificationActive = false;
              }
            },

            getValidationState({ dirty, validated, valid = null }, fieldName) {
                if (this.isCurrentPasswordForceInvalid && fieldName == 'currentPassword' || this.isNewPasswordForceInvalid && fieldName == 'newPassword') {
                  return false; // Set the validation state to false to show as invalid
                }
                return dirty || validated ? valid : null;
            },
            async changePassword() {
              try {

                // Lets revalidate the forms 
                const validationResult = await this.$refs.observer.validate();
                
                // If theres validation error now we'll scroll the view to the error (User friend leetsg)
                if (!validationResult) {

                    // This will scroll to errors 
                    this.$nextTick(() => {
                        // We querySelect with .is-invalid class 
                        document.querySelector('.is-invalid').scrollIntoView({block: "center", behavior: "smooth"})
                    });
                    return;
                }

                await this.changeUserPassword({ currentPassword: this.currentPassword, newPassword: this.newPassword }).then(data => {
                  if (data.status == 'ok') {
                    let toastData = {
                      type: 'success',
                      title: 'Success!',
                      message:  data.message
                    }
                    this.$router.push({ name: 'profile' , query: { toastData: toastData } });
                  }
                }).catch(error => {
                    console.log("result: ", error);
                    if(error.errorCode == 'NotAuthorizedException')
                    {
                      this.isCurrentPasswordForceInvalid = true;
                      this.$refs.currentPass.validate();
                      this.$nextTick(() => {
                          document.querySelector('.is-invalid').scrollIntoView({block: "center", behavior: "smooth"})
                      });
                      this.$toast.showToast('danger', "Failed!", error.message);
                    }
                    else if(error.errorCode == 'OldPasswordMatchesException')
                    {
                        this.isNewPasswordForceInvalid = true;
                        this.$refs.newPassX.validate();
                        this.$nextTick(() => {
                            document.querySelector('.is-invalid').scrollIntoView({block: "center", behavior: "smooth"})
                        });
                        this.$toast.showToast('danger', "Failed!", error.message);
                    }
                    else 
                    {
                      this.$toast.showToast('danger', "Failed!", error.message);
                    }
                });
                
              
              } catch (error) { 
                console.log("An error occurred: ", error);
                this.$toast.showToast('danger', "Error", error.message);
              }
            },
        },
    };
</script>
<style scoped>
    .password-verification {
        font-size: 11px;
        font-weight: 500;
    }
   

    .custom-style {
        max-width: 615px;
        /* Set maximum width */
        width: 100%;
        /* Take up available width up to the maximum */
        height: auto;
        /* Automatically adjust height based on content */
        padding: 24px 20px;
        border-radius: 8px;
        gap: 24px;
    }

    .no-border-right {
        border-right: none;
    }

    .input-text-green {
        border-color: #51d28c;
    }

    .input-text-red {
        border-color: #f34e4e;
    }

    .toggle-password {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        cursor: pointer;
        background: none;
        color: #e1e1e1;
    }
    .custom-invalid-feedback {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 87.5%;
        color: #f34e4e;
    }

   
   
</style>